// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import noUiSlider from 'nouislider'
import refs from '../helpers/refs'

class CFilters {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.init()
  }

  init () {
    if (this.$refs.rangeSlider) {
      this.rangeSlider(this.$refs.rangeSlider)
    }

    this.$refs.clearFilters?.addEventListener('click', () => {
      this.clearFilters()
    })

    this.$refs.hideModal?.addEventListener('click', () => {
      this.hideModal()
    })

    this.$refs.showResults?.addEventListener('click', () => {
      this.showResults()
    })

    this.$refs.modelForm?.addEventListener('submit', (e) => {
      e.preventDefault()
      const action = this.$refs.modelForm.action
      const value = this.$refs.modelInput.value.trim().toUpperCase()
      location.href = `${action}/Model_${value}`
    })

    if (this.$refs.modelNumber) {
      this.$refs.modelNumber.querySelector('select').addEventListener('change', (e) => {
        // need to split pathname to remove any existing part filter
        const collection = window.location.pathname.split('/Model_')
        location.href = collection[0] + '/' + e.target.value
      })
    }

    document.addEventListener('cFilters:clearFilters', () => {
      this.clearFilters()
    })

    document.addEventListener('cFilters:showModal', () => {
      this.showModal()
    })

    window.addEventListener('resize', () => {
      this.hideModal()
    })
  }

  rangeSlider (el) {
    const min = Number(el.dataset.min) || 30
    const max = Number(el.dataset.max) || 60

    this.slider = noUiSlider.create(el, {
      connect: true,
      range: { min, max },
      start: [min, max],
      step: 1
    })

    this.slider.on('change', () => {
      console.log('noUiSlider change event:', el.noUiSlider.get())
    })
  }

  clearFilters () {
    this.$refs.input.forEach((el) => {
      el.checked = false
    })

    if (this.slider) {
      this.slider.reset()
    }
  }

  hideModal () {
    // enableBodyScroll(this.$root)
    this.$root.classList.remove('--show')
  }

  showModal () {
    // disableBodyScroll(this.$root)
    this.$root.classList.add('--show')
  }

  showResults () {
    this.hideModal()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-filters').forEach(el => new CFilters(el))
})
